import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { type CategoryBrowserTreatment } from '@/hooks/use-category-browser.ts';

import { sectionHeading } from '@/styles/sectionHeading.ts';

import { TreatmentTypeCard } from './treatment-type-card.tsx';

interface Props {
    name: string;
    treatments: CategoryBrowserTreatment[];
}

const useStyles = makeStyles((theme: any) => ({
    container: {
        paddingTop: '1.5rem',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.875rem',
    },
    groupName: {
        ...sectionHeading(theme),
    },
    divider: {
        flex: 1,
        height: 1,
        backgroundColor: theme.palette.grey[300],
    },
    count: {
        ...theme.typography.body2,
        color: theme.palette.common.darkGrey,
        opacity: 0.5,
        margin: 0,
        whiteSpace: 'nowrap',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.875rem',
        marginTop: '0.875rem',
        alignItems: 'stretch',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
        },
    },
}));

export const TreatmentTypeGroup = ({ name, treatments }: Props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const typeCount = new Set(treatments.map((treatment) => treatment.treatmentKey)).size;
    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <Typography className={classes.groupName} component="h3">
                    {name}
                </Typography>
                <span className={classes.divider} />
                <Typography className={classes.count} component="span">
                    {t('TreatmentTypesCount', { count: typeCount })}
                </Typography>
            </div>
            <div className={classes.grid}>
                {treatments.map((treatment) => (
                    <TreatmentTypeCard
                        key={treatment.rowKey}
                        name={treatment.name}
                        isOnline={treatment.isOnline}
                        isSelected={treatment.isSelected}
                        meta={treatment.meta}
                        onSelect={treatment.select}
                        dataTestId={`category-browser-treatment-${treatment.rowKey}`}
                    />
                ))}
            </div>
        </div>
    );
};
